customElements.define('header-group', class extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.lastScrollY = 0;
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.setHeaderHeight();

    this.megaMenuItems = document.querySelectorAll('.mega-menu__inner');
    this.stickyHeader = document.querySelector('sticky-header');

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.setHeaderHeight);

    if (this.stickyHeader) {
      this.stickyHeader.addEventListener('mouseleave', this.onMouseLeave);
    }

    this.megaMenuItems.forEach((item) => {
      item.addEventListener('mouseleave', this.onMouseLeave);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.setHeaderHeight());
    }

    if (typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this._resizeObserver.observe(this);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.setHeaderHeight);
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  setHeaderHeight() {
    // Ignore mega menu height so opening it doesn't push page content via --header-height.
    const megaMenu = this.querySelector('.mega-menu');
    const megaMenuHeight = megaMenu ? megaMenu.offsetHeight : 0;
    const height = Math.max(this.offsetHeight - megaMenuHeight, 0);
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  onMouseLeave() {
    this.megaMenuItems.forEach((item) => {
      item.classList.remove('mega-menu__inner--shown');
    });

    const sectionHeader = this.querySelector('.section-header');
    if (sectionHeader) {
      sectionHeader.classList.remove('menu-open');
    }
  }

  show() {
    this.classList.remove('scrolled');
  }

  hide() {
    this.classList.add('scrolled');
  }

  handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY < this.lastScrollY) {
      this.show();
    } else if (currentScrollY > this.lastScrollY && currentScrollY > 70) {
      this.hide();
    }

    this.lastScrollY = currentScrollY;
  }
});


customElements.define('header-drawer-new', class extends HTMLElement {
  constructor() {
    super();

    this.toggler = this.querySelector('.js-toggle-nav-menu');
    this.navMenu = document.querySelector('.navbar-menu');
    this.toggler?.addEventListener('click', this.toggleMenu.bind(this));
  }

  toggleMenu() {
    this.classList.toggle('is-open');
    this.navMenu.classList.toggle('is-open');
  }
});



class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.megaMenuItems = document.querySelectorAll('.mega-menu__inner');

    this.addEventListener('mouseover', this.onMouseOver.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseOver() {
    this.megaMenuItems.forEach((item) => {
      item.classList.remove('mega-menu__inner--shown');
    });
    if(!this.dataset.position){
      document.querySelector('.section-header')?.classList.remove('menu-open');
      return;
    }
    document.querySelector(`.mega-menu__inner[data-position="${this.dataset.position}"]`)?.classList.add('mega-menu__inner--shown');
    document.querySelector('.section-header')?.classList.add('menu-open');
  }

  close() {
    this.megaMenuItems.forEach((item) => {
      item.classList.remove('mega-menu__inner--shown');
    });
    document.querySelector('.section-header')?.classList.remove('menu-open');
  }
}

customElements.define('header-menu', HeaderMenu);
